import { call, take, takeLatest } from "redux-saga/effects";
import {
  CREATE_FIELD_FORCE,
  DELETE_FIELD_FORCE,
  DESIGNATION_LIST,
  EDIT_FIELD_FORCE,
  ENABLE_DISABLE_HEADQUARTER,
  ENALBE_DISABLE_FIELD_FORCE,
  FETCH_DESIGNATION_DETAIL,
  FETCH_DESIGNATION_LIST,
  FF_CUSTOMERS_LIST,
  FIELD_FORCE_ADMIN_DETAIL,
  FIELD_FORCE_ADMIN_EDIT_DETAIL,
  FIELD_FORCE_ADMIN_OVERRIDE,
  FIELD_FORCE_ADMIN_VERIFY_DETAIL,
  FIELD_FORCE_DESIGNATION_CREATE,
  FIELD_FORCE_DESIGNATION_DELETE,
  FIELD_FORCE_DESIGNATION_EDIT,
  FIELD_FORCE_DESIGNATION_VERSION_DETAIL,
  FIELD_FORCE_DESIGNATION_VERSION_LIST,
  FIELD_FORCE_DETAIL,
  FIELD_FORCE_HEADQUARTER_CREATE,
  FIELD_FORCE_HEADQUARTER_DELETE,
  FIELD_FORCE_HEADQUARTER_DETAIL,
  FIELD_FORCE_HEADQUARTER_EDIT,
  FIELD_FORCE_HEADQUARTER_LIST,
  FIELD_FORCE_HEADQUARTER_VERSION_DETAIL,
  FIELD_FORCE_HEADQUARTER_VERSION_LIST,
  FIELD_FORCE_LIST,
  FIELD_FORCE_VERSION_DETAIL,
  FIELD_FORCE_VERSION_LIST,
  HEAD_QUATERS_LIST,
  LINK_EMPLOYEE,
  LINK_EMP_LIST,
  REPORTING_FIELD_FORCE_LIST,
  REPORTING_MANAGER_LIST,
  REPORT_DESIGNATION_LIST,
  SUBORDINATES_LIST,
  UPDATE_CUSTOMERS_REPORTING_MANAGER,
  UPDATE_SUBORDINATES_REPORTING_MANAGER,
} from "../actions/types";
import * as fieldForceApis from "../apis/fieldForceApis";

export function* fieldForceListWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceListApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceDetailWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceDetailApi, {
      user_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceDeleteWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceDeleteApi, {
      user_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceEnableDisableWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceEnableDisableApi, {
      user_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceCreateWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceCreateApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceEditWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceEditApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceDesignationListWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceDesignationListApi);
    if (res.status == "200") {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
        approval_level: ele.approval_level,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchReportingManagerListWorker(action) {
  try {
    const res = yield call(fieldForceApis.reportingManagerListApi, action.data);
    if (res.status == "200") {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchHeadQuaterListWorker(action) {
  try {
    const res = yield call(fieldForceApis.headQuaterListApi);
    if (res.status == "200") {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceVersionListWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceVersionList, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onSuccess(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceVersionDetailWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceVersionDetail, {
      user_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onSuccess(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchDesignationListWorker(action) {
  try {
    const res = yield call(fieldForceApis.fetchDesignationListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchDesignationDetailWorker(action) {
  try {
    const res = yield call(fieldForceApis.fetchDesignationDetailApi, {
      designation_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceDesignationCreateWorker(action) {
  try {
    const res = yield call(
      fieldForceApis.fieldForceDesignationCreateApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceDesignationEditWorker(action) {
  try {
    const res = yield call(
      fieldForceApis.fieldForceDesignationEditApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceDesignationDeleteWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceDesignationDeleteApi, {
      designation_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceDesignationVersionListWorker(action) {
  try {
    const res = yield call(
      fieldForceApis.fieldForceDesignationVersionList,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceDesignationVersionDetailWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceDesignationVersionDetail, {
      designation_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* reportingDesignationListWorker(action) {
  try {
    const res = yield call(fieldForceApis.reportingDesignationListApi, {
      approval_level: action.data,
    });

    if (res.status == "200") {
      console.log(res);
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
      console.log(newArr);
      // yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceLinkEmpListWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceLinkEmpListApi);
    let newArr = res.data.data.map((ele) => ({
      value: ele.id,
      label: ele.employee_id,
    }));
    if (res.status == "200") {
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceLinkEmployeeWorker(action) {
  try {
    const res = yield call(
      fieldForceApis.fieldForceLinkEmployeeApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchHeadQuarterListWorker(action) {
  try {
    const res = yield call(
      fieldForceApis.fieldForceHeadQuarterListApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceHeadQuarterDetailWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceHeadQuarterDetailApi, {
      head_quater_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceHeadQuarterCreateWorker(action) {
  try {
    const res = yield call(
      fieldForceApis.fieldForceHeadQuarterCreateApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceHeadQuarterEditWorker(action) {
  try {
    const res = yield call(
      fieldForceApis.fieldForceHeadQuarterEditApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceHeadQuarterVersionListWorker(action) {
  try {
    const res = yield call(
      fieldForceApis.fieldForceHeadQuarterVersionListApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onSuccess(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceHeadQuarterVersionDetailWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceHeadQuarterVersionDetail, {
      head_quater_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* headQuarterEnableDisableWorker(action) {
  try {
    const res = yield call(fieldForceApis.headQuarterEnableDisableApi, {
      head_quater_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceheadQuarterDeleteWorker(action) {
  try {
    const res = yield call(fieldForceApis.headQuarterDeleteApi, {
      head_quater_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchFieldForceAdminWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceAdminViewApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchFieldForceAdminOverrideWorker(action) {
  try {
    const res = yield call(
      fieldForceApis.fieldForceAdminOverrideApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceAdminVerifyWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceAdminVerifyApi, {
      employee_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceAdminEditWorker(action) {
  try {
    const res = yield call(fieldForceApis.fieldForceAdminEditApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* subordinatesListWorker(action) {
  try {
    const res = yield call(fieldForceApis.subordinatesListApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* reportingManagersListWorker(action) {
  try {
    const res = yield call(fieldForceApis.repostingManagesListApi, action.data);
    console.log(res);
    if (res.status == "200") {
      let newArr = res.data.data.ffUsers.map((ele) => ({
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* updateSubordinatesReportingManagerWorker(action) {
  try {
    const res = yield call(
      fieldForceApis.updatingSubordinatesRepostingManagesApi,
      action.data
    );
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* updateCustomersReportingManagerWorker(action) {
  try {
    const res = yield call(
      fieldForceApis.updatingCustomersRepostingManagesApi,
      action.data
    );
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* ffCustomersListWorker(action) {
  try {
    const res = yield call(fieldForceApis.ffCustomersListApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForcListWatcher() {
  yield takeLatest(FIELD_FORCE_LIST, fieldForceListWorker);
}

export function* fieldForceDetailWatcher() {
  yield takeLatest(FIELD_FORCE_DETAIL, fieldForceDetailWorker);
}

export function* fieldForceDeleteWatcher() {
  yield takeLatest(DELETE_FIELD_FORCE, fieldForceDeleteWorker);
}

export function* fieldForceEnableDisableWatcher() {
  yield takeLatest(ENALBE_DISABLE_FIELD_FORCE, fieldForceEnableDisableWorker);
}

export function* fieldForceCreateWatcher() {
  yield takeLatest(CREATE_FIELD_FORCE, fieldForceCreateWorker);
}

export function* fieldForceEditWatcher() {
  yield takeLatest(EDIT_FIELD_FORCE, fieldForceEditWorker);
}

export function* fieldForceDesignationListWatcher() {
  yield takeLatest(DESIGNATION_LIST, fieldForceDesignationListWorker);
}

export function* fetchReportingManagerListWatcher() {
  yield takeLatest(REPORTING_MANAGER_LIST, fetchReportingManagerListWorker);
}

export function* fetchHeadQuaterListWatcher() {
  yield takeLatest(HEAD_QUATERS_LIST, fetchHeadQuaterListWorker);
}

export function* fieldForceVersionListWatcher() {
  yield takeLatest(FIELD_FORCE_VERSION_LIST, fieldForceVersionListWorker);
}

export function* fieldForceVersionDetailWatcher() {
  yield takeLatest(FIELD_FORCE_VERSION_DETAIL, fieldForceVersionDetailWorker);
}

export function* fetchDesignationListWatcher() {
  yield takeLatest(FETCH_DESIGNATION_LIST, fetchDesignationListWorker);
}

export function* fetchDesignationDetailWatcher() {
  yield takeLatest(FETCH_DESIGNATION_DETAIL, fetchDesignationDetailWorker);
}

export function* fieldForceDesignationCreateWatcher() {
  yield takeLatest(
    FIELD_FORCE_DESIGNATION_CREATE,
    fieldForceDesignationCreateWorker
  );
}

export function* fieldForceDesignationEditWatcher() {
  yield takeLatest(
    FIELD_FORCE_DESIGNATION_EDIT,
    fieldForceDesignationEditWorker
  );
}

export function* fieldForceDesignationDeleteWatcher() {
  yield takeLatest(
    FIELD_FORCE_DESIGNATION_DELETE,
    fieldForceDesignationDeleteWorker
  );
}

export function* fieldForceDesignationVersionListWatcher() {
  yield takeLatest(
    FIELD_FORCE_DESIGNATION_VERSION_LIST,
    fieldForceDesignationVersionListWorker
  );
}

export function* fieldForceDesignationVersionDetailWatcher() {
  yield takeLatest(
    FIELD_FORCE_DESIGNATION_VERSION_DETAIL,
    fieldForceDesignationVersionDetailWorker
  );
}

export function* fieldForceLinkEmpListWatcher() {
  yield takeLatest(LINK_EMP_LIST, fieldForceLinkEmpListWorker);
}

export function* fieldForceLinkEmployeeWatcher() {
  yield takeLatest(LINK_EMPLOYEE, fieldForceLinkEmployeeWorker);
}

export function* fieldForceHeadQuarterListWatcher() {
  yield takeLatest(FIELD_FORCE_HEADQUARTER_LIST, fetchHeadQuarterListWorker);
}

export function* fieldForceHeadQuarterDetailsWatcher() {
  yield takeLatest(
    FIELD_FORCE_HEADQUARTER_DETAIL,
    fieldForceHeadQuarterDetailWorker
  );
}

export function* fieldForceHeadQuarterCreateWatcher() {
  yield takeLatest(
    FIELD_FORCE_HEADQUARTER_CREATE,
    fieldForceHeadQuarterCreateWorker
  );
}

export function* fieldForceHeadQuarterEditWatcher() {
  yield takeLatest(
    FIELD_FORCE_HEADQUARTER_EDIT,
    fieldForceHeadQuarterEditWorker
  );
}

export function* fieldForceHeadQuarterVersionListWatcher() {
  yield takeLatest(
    FIELD_FORCE_HEADQUARTER_VERSION_LIST,
    fieldForceHeadQuarterVersionListWorker
  );
}

export function* fieldForceHeadQuarterVersionDetailWatcher() {
  yield takeLatest(
    FIELD_FORCE_HEADQUARTER_VERSION_DETAIL,
    fieldForceHeadQuarterVersionDetailWorker
  );
}

export function* headQuarterEnableDisableWatcher() {
  yield takeLatest(ENABLE_DISABLE_HEADQUARTER, headQuarterEnableDisableWorker);
}

export function* fieldForceheadQuarterDeleteWatcher() {
  yield takeLatest(
    FIELD_FORCE_HEADQUARTER_DELETE,
    fieldForceheadQuarterDeleteWorker
  );
}

export function* fetchFieldForceAdminWatcher() {
  yield takeLatest(FIELD_FORCE_ADMIN_DETAIL, fetchFieldForceAdminWorker);
}

export function* fieldForceAdminVerifyWatcher() {
  yield takeLatest(
    FIELD_FORCE_ADMIN_VERIFY_DETAIL,
    fieldForceAdminVerifyWorker
  );
}

export function* fieldForceAdminEditWatcher() {
  yield takeLatest(FIELD_FORCE_ADMIN_EDIT_DETAIL, fieldForceAdminEditWorker);
}

export function* reportingDesignationListWatcher() {
  yield takeLatest(REPORT_DESIGNATION_LIST, reportingDesignationListWorker);
}
export function* fetchFieldForceAdminOverrideWatcher() {
  yield takeLatest(
    FIELD_FORCE_ADMIN_OVERRIDE,
    fetchFieldForceAdminOverrideWorker
  );
}
export function* subordinatesListWatcher() {
  yield takeLatest(SUBORDINATES_LIST, subordinatesListWorker);
}
export function* reportingManagersListWatcher() {
  yield takeLatest(REPORTING_FIELD_FORCE_LIST, reportingManagersListWorker);
}
export function* updateSubordinatesReportingManagersWatcher() {
  yield takeLatest(
    UPDATE_SUBORDINATES_REPORTING_MANAGER,
    updateSubordinatesReportingManagerWorker
  );
}
export function* ffCustomersListWatcher() {
  yield takeLatest(FF_CUSTOMERS_LIST, ffCustomersListWorker);
}
export function* updateCustomersReportingManagerWatcher() {
  yield takeLatest(
    UPDATE_CUSTOMERS_REPORTING_MANAGER,
    updateCustomersReportingManagerWorker
  );
}
